import { SupportedLocale } from '@99designs/i18n';
import { TrustpilotWidgetConfig } from './TrustpilotWidget';

export const isTrustpilotEnabledLocale = (locale: string): locale is EnabledLocale => {
    return LOCALE_CONFIG[locale as EnabledLocale] !== undefined;
};

export const LOCALE_CONFIG = {
    'en-AU': {
        href: 'https://au.trustpilot.com/review/vistaprint.com.au',
        businessUnitID: '56839d060000ff0005871345',
        token: '4dd6728b-fcda-4476-b807-c7fcd2f0b8d8',
    },
    'en-GB': {
        href: 'https://uk.trustpilot.com/review/www.vistaprint.co.uk',
        businessUnitID: '48b829e50000640005032818',
        token: '0817f27a-fa76-435d-8109-0909b55d889b',
    },
    'en-US': {
        href: 'https://www.trustpilot.com/review/www.vistaprint.com',
        businessUnitID: '46d43538000064000500bc94',
        token: 'd92a0d47-0a8a-4c57-8916-f6d9bd51f671',
    },
    'en-CA': {
        href: 'https://ca.trustpilot.com/review/vistaprint.ca',
        businessUnitID: '57338f0b0000ff00058cbbdf',
        token: '1e3fd14f-8e8b-4160-8bf8-b1edab81a016',
    },
} satisfies Partial<Record<SupportedLocale, TrustpilotWidgetConfig>>;

export type EnabledLocale = keyof typeof LOCALE_CONFIG;
